// extracted by mini-css-extract-plugin
export default {"synergyVideoContainer":"synergy-video-dialog_synergyVideoContainer__QMr+S","buttonContainer":"synergy-video-dialog_buttonContainer__5WnNa"};